$(document).on('click', '.offer-badge__close', function() {
  $(this).parents('.offer-badge').hide();
})
